<style scoped>
    textarea:focus {
        outline-style: solid;
        outline-width: 0px;
    }
</style>
<script>

import Form from 'form-backend-validation';
import axios from 'axios';
import autosize from 'autosize';
import moment from 'moment';
import trans from '../mixins/trans';

moment.locale('de');

export default {

    mixins: [
        trans
    ],

    props: [
        'trainingId',
        'listenOnRated',
        'id'
    ],

    data() {
        return {
            success: true,
            count: null,
            visible: null,
            offset: 10,
            limit: 10,
            busy: false,
            summary: {
                total: 0,
                avg: 0,
                ratings: [
                    0, 0, 0, 0, 0
                ]
            },
            isEditing: false,
            ratings: [],
            myRating: null,
            form: new Form({
                rating: null,
                reviewComment: ''
            }, {
                resetOnSuccess: false,
            }),
        };
    },

    filters: {
        formatDate(value) {
            return moment(value).format('DD. MMMM Y')
        }
    },

    mounted() {
        this.fetchRatings();
        this.$root.$on('rated', (id) => {if(this.listenOnRated && this.id !== id){this.fetchRatings()}});

        autosize(this.$refs.reviewArea);
    },

    methods: {

        async fetchRatings() {

            let data = await axios.get(`/api/ratings/${this.trainingId}?offset=${this.offset}`)
                .catch(function(e){if(e.code!=='ECONNABORTED'){throw e;}});

            this.busy = false;

            this.offset = this.offset + this.limit;

            this.ratings = data.data.ratings;
            this.myRating = data.data.myRating;
            this.count = data.data.count;
            this.visible = data.data.visible;
            this.summary = data.data.summary;
        },

        reset(event) {
            this.form.errors.clear(event.target.name);
            this.success = false;
        },

        onSubmit() {
            this.form.post(`/api/ratings/${this.trainingId}`)
                .then(response => {
                    this.form.rating = 0;
                    this.form.reviewComment = '';
                    this.success = true;
                    this.isEditing = false;

                    autosize.update(this.$refs.reviewArea);

                    this.fetchRatings();

                    this.$notifications.success(this.__("Thank you for your review."), [
                    {
                        text: this.__('Ratings'),
                        classes: 'btn btn-default',
                        callback: () => {
                            document.location.href=document.location.href.replace(/#learningContent/,'#ratings');
                        }
                    }]);

                    $('#flashRatingModalCenter').modal('hide');
                    this.$root.$emit('rated',this.id);
                });
        },

        deleteRating(){
            swal(this.__('Are you sure you want to delete this rating, including the review?'), {
              buttons: [this.__('Cancel'), this.__('Yes')],
            })
            .then((value) => {
                if (value !== null) {
                    this.form.delete(`/api/ratings/${this.trainingId}`)
                .then(response => {
                    this.form.rating = 0;
                    this.form.reviewComment = '';
                    this.success = true;
                    this.isEditing = false;

                    autosize.update(this.$refs.reviewArea);

                    this.fetchRatings();
                });
                }
            });
        },

        loadMore() {
            if (this.visible !== null && this.visible > this.ratings.length && ! this.busy) {
                this.busy = true;
                this.fetchRatings();
            }

            if (this.visible === this.ratings.length) {
                const loadMore = document.getElementById("loadMore");
                loadMore.style.display = "none";
            }
        },

        barWidth(count) {
            if (count === 0) {
                return '0%';
            }
            return (count / this.summary.total) * 100 + '%';
        },

        editMyRating() {
            this.isEditing = true;

            this.form.rating = this.myRating.rating;
            this.form.reviewComment = this.myRating.comment;
        },

        cancelMyRating() {
            this.isEditing = false;
        }
    }
}
</script>